import NumberFormatML from './NumberFormatML';

export default (props) => {
  return <NumberFormatML {...props} />;
};
